import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { showDuration } from 'src/app/core/_constants/helper';
import { ValidationService } from 'src/app/core/_services/common/validation.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public chargeForm: FormGroup;
  submitted: boolean = false;
  methodArray: any = [
    { key: 'In Person', value: 'In Person' },
    { key: 'Mail', value: 'Mail' },
  ]

  constructor(public dialogRef: MatDialogRef<PaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public validationService: ValidationService) {
  }


  ngOnInit(): void {
    this.chargeForm = this.createForm();
    console.log(this.data)
  }

  createForm() {
    return this.fb.group({
      notes: [''],
      cashMethod: ['', Validators.required]
    })
  }

  get f() { return this.chargeForm.controls; }

  close(value: Boolean) {
    if (this.chargeForm.valid) {
      this.dialogRef.close(value);
    }
  }

  chargeSubmit() {
    this.submitted = true;
    if (this.chargeForm.valid) {
      let data = {
        paymentMethod: 1,
        payeeDetails: {
          cashMethod: this.chargeForm.value.cashMethod,
          notes: this.chargeForm.value.notes,
        }
      }
      if (this.data.subNewData) {
        data['paymentMode'] = 2;
        data['paymentMethod'] = 1;
        data['isManage'] = true;
        data['companyId'] = this.data.subNewData.companyId;
        data['duration'] = this.data.subNewData.duration;
        data['permissionId'] = this.data.subNewData.permissionId;
        data['packageName'] = this.data.subNewData.packageName;
        data['packageId'] = this.data.subNewData.packageId;
        data['amount'] = this.data.subNewData.amount;
        data['addOns'] = this.data.subNewData.addOns;
        data['numberOfTrucks'] = this.data.subNewData.numberOfTrucks

      }
      this.dialogRef.close(data)
    }
  }




  setAmount(event) {
    if (event.value == 'complete') {
      this.chargeForm.patchValue({
        amount: Number(this.data?.data?.balanceRemaining).toFixed(2)
      })
    } else {
      this.chargeForm.patchValue({
        amount: ''
      })
    }
  }

  getMethod() {
    let methodArray = this.methodArray.filter((x: any) => x.type.includes(Number(this.data.type)))
    return methodArray
  }

  getDuration(data) {
    return showDuration(data)
  }

}
